<div class="profile-container">
  <div class="profile-content">
    <div class="personal-details">
      <div class="header-block">
        <div class="header-title">
          <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="add-block">
          <select style="text-align: center;width: 150px;" class="form-control" [(ngModel)]="isAudit" (change)="getAssetAuditInfoByAudited()">
            <option *ngFor="let status of audit" [value]="status.value">
              {{ status.key }}
            </option>
          </select>
          <select style="text-align: center;margin-left: 10px;" name="" id="year" class="form-control" [(ngModel)]="financialYear" (change)="getAllAssetAuditInfoByFinancialYear()" >
            <option [value]="list.year" *ngFor="let list of yearList">{{list.year}}</option>
          </select>
          <!-- <div class="search">
            <form autocomplete="off" >
              <input type="text" placeholder="search" (keyup.enter)="getObjectInfoByWildSearch()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
            </form>
            <i class="bi bi-search" (click)="getObjectInfoByWildSearch()"></i>
          </div> -->
          <button data-toggle="modal" title="Add" (click)="addAssetAuditInfo()" *ngIf="this.assetAuditInfoList.length == 0 && isAudit == 'All'"> {{ 'asset-audit-info.generate' | translate }}</button>
          <button (click)="Verify()" *ngIf="isAudit == 'false'"> {{ 'asset-audit-info.verify' | translate }}</button>
          <!-- <button data-toggle="modal" title="Clone Asset" data-target="#cloneDeviceModal"><i class="bi bi-plus-lg"></i> Clone</button> -->

          <!-- <div class="filter-icon">
            <i class="bi bi-funnel" title="Filter" (click)="toggleFilter()"></i>
            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
          </div> -->
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12 table-data">
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 4%;" *ngIf="isAudit == 'false'"></th>
                <th style="width: 11%;" *ngIf="isAudit == 'false'">{{ 'asset-audit-info.assetId' | translate }}</th>
                <th style="width: 16%;" *ngIf="isAudit != 'false'">{{ 'asset-audit-info.assetId' | translate }}</th>
                <th style="width: 20%;">{{ 'asset-audit-info.assetName' | translate }}</th>
                <th style="width: 20%;">{{ 'asset-audit-info.assetVerificationOn' | translate }}</th>
                <th style="width: 20%;">{{ 'asset-audit-info.assetVerificationByUser' | translate }}</th>
                <th style="width: 15%;">{{ 'asset-audit-info.remarks' | translate }}</th>
                <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
              </tr>
            </thead>
          </table>
          <div *ngIf="!isLoading">
            <div class="data-view" id="{{list.id}}" *ngFor="let list of assetAuditInfoList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count
              }  ;let i = index">
 
              <p style="width: 4%;" *ngIf="isAudit == 'false'">
                <input type="checkbox" [(ngModel)]="list.audited">
              </p>
              <p style="width: 11%;" *ngIf="isAudit == 'false'">{{list.assetId}}</p>
              <p style="width: 16%;" *ngIf="isAudit != 'false'">{{list.assetId}}</p>
              <p style="width: 20%;">{{list.assetName || '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -- '}}</p>
              <p style="width: 20%;">{{list.assetVerificationOn || '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -- '}}</p>
              <p style="width: 20%;">{{list.assetVerificationByUser || '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -- '}}</p>
              <p style="width: 15%;">{{list.remarks || '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; --'}}</p>
              <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                <i data-toggle="modal" title="View" (click)="getSingleAssetAudit(list)" data-target="#viewModal" class="bi bi-eye-fill"></i>
              </p>
            </div>
          </div>


          <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>

          <div class="loader" *ngIf="!isLoading && assetAuditInfoList.length == 0">
            <div class="no-data">
              <img src="assets/no-data-6.png" alt="">
              <p>no data found</p>
            </div>
          </div>

          <div class="paginator">
            <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
              [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
            </p-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>







<div class="modal fade" id="deviceModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Audit
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="clearData()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
      <div class="">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12" >
            <div class="form-group">
                <label>Asset <span class="required-field">*</span></label>
                <ng-multiselect-dropdown
                    [placeholder]="'select asset'"
                    [settings]="objectInfoDropdownSettings"
                    [data]="objectInfoList"
                    [(ngModel)]="objectInfoSelectedList"
                    class="form-control"
                    style="padding: 0;border: none"
                    [ngModelOptions]="{standalone: true}"
                    (onSelect)="onItemSelect($event)"
                    (onSelectAll)="onSelectAll($event)"
                    >
                </ng-multiselect-dropdown>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 col-md-6 list-block" *ngFor="let list of auditList">
            <span class="remove"><i (click)="removeAudit(list.objectInfoId)" class="bi bi-x-lg"></i></span>
            <div class="list">
              <div>
                <label>Name :</label> 
                <p>{{list.givenName || '--'}}</p>
              </div>

              <div>
                <label>Condition :</label> 
                <p>{{list.objectCondition || '--'}}</p>
              </div>

              <div>
                <label>Original Cost :</label> 
                <p>{{list.originalCost || '--'}}</p>
              </div>

            </div>
          </div>
        </div>


      </div>
      </div>
      <div class="modal-footer">
        <button type="button" id="closeModalAdd" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="addAssetAuditInfo()" class="btn btn-primary">Save</button>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'asset-audit-info.headings.detail' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="clearData()"></i>
          </span>
          <button type="button" (click)="verifyClick()" *ngIf="!isVerify && singleAssetData[0]?.assetVerificationByUser == ''" class="btn btn-success">{{ 'asset-audit-info.verify' | translate }}</button>

        </h5>
      </div>
      <div class="modal-body">


<div *ngFor="let list of singleAssetData" class="row mb-3">

  <div class="col-md-6 col-lg-6">
    <label>{{ 'asset-audit-info.assetName' | translate }} :</label>
    <p>{{ list.assetName || '--' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>{{ 'asset-audit-info.assetPurchaseValue' | translate }} :</label>
    <p>{{ list.assetPurchaseValue || '--' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>{{ 'asset-audit-info.assetCurrentEstimatedValue' | translate }} :</label>
    <p>{{ list.assetCurrentEstimatedValue || '--' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>{{ 'asset-audit-info.assetCondition' | translate }} :</label>
    <p>{{ list.assetCondition || '--' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>{{ 'asset-audit-info.assetVerificationOn' | translate }} :</label>
    <p>{{ list.assetVerificationOn || '--' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>{{ 'asset-audit-info.assetVerificationByUser' | translate }} :</label>
    <p>{{ list.assetVerificationByUser || '--' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>{{ 'asset-audit-info.assetVerificationByUserQualification' | translate }} :</label>
    <p>{{ list.assetVerificationByUserQualification || '--' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>{{ 'asset-audit-info.assetVerificationByCompany' | translate }} :</label>
    <p>{{ list.assetVerificationByCompany || '--' }}</p>
  </div>

  <div class="col-md-12 col-lg-12" *ngIf="!isVerify">
    <label>{{ 'asset-audit-info.remarks' | translate }} :</label>
    <p>{{ list.remarks || '--' }}</p>
  </div>

  <div class="col-md-12 col-lg-12 img-block">
    <label>{{ 'asset-audit-info.assetOldImages' | translate }} : <i *ngIf="isVerify" (click)="addAssetImageBtn()" class="bi bi-plus-circle"></i></label>
    <div class="img-list">
      <img src="{{img}}" *ngFor="let img of list.assetOldImages" alt="">
      <img src="{{img}}" *ngFor="let img of assetCurrentImages" alt="">
    </div>
      <div hidden="true">
        <input #imageInput
          type="file" id="add-assetImage-btn"
          accept="image/*" hidden="true"
          (change)="onAssetChange($event)">
    </div>
  </div>

  <div class="col-md-12 col-lg-12" *ngIf="isVerify">
    <label>{{ 'asset-audit-info.remarks' | translate }} :</label>
    <textarea name="" id="" class="form-control" [(ngModel)]="remarks"></textarea>
  </div>


</div>

      </div>
      <div class="modal-footer">
        <button type="button" id="" *ngIf="isVerify" (click)="verifyAsset()" class="btn btn-success">{{ 'generic.submit' | translate }}</button>
        <button type="button" id="closeModalView" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
      </div>
    </div>
  </div>
</div>